import { Search, X } from 'lucide-react';

// Admin list search box. Deliberately a filter, not a jump-to: typing narrows
// the list in place and everything non-matching disappears, so what's left on
// screen IS the result set. Staff were scrolling a 70-row product table to find
// one card.
export default function AdminSearch({ value, onChange, placeholder, resultCount, totalCount }) {
  return (
    <div style={{ marginBottom: 14 }}>
      <div style={{ position: 'relative', maxWidth: 420 }}>
        <Search
          size={15}
          style={{
            position: 'absolute', left: 11, top: '50%', transform: 'translateY(-50%)',
            color: 'var(--text-muted)', pointerEvents: 'none',
          }}
        />
        <input
          className="sv-input"
          type="search"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          style={{ paddingLeft: 34, paddingRight: value ? 34 : 12, width: '100%' }}
        />
        {value && (
          <button
            type="button"
            onClick={() => onChange('')}
            aria-label="Clear search"
            style={{
              position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)',
              background: 'none', border: 'none', padding: 4, cursor: 'pointer',
              color: 'var(--text-muted)', display: 'flex',
            }}
          >
            <X size={14} />
          </button>
        )}
      </div>
      {value && (
        <div style={{ fontSize: '0.74rem', color: 'var(--text-muted)', marginTop: 5 }}>
          {resultCount} of {totalCount} match “{value}”
        </div>
      )}
    </div>
  );
}

// Splits the query on whitespace and requires EVERY term to appear somewhere in
// the row's searchable text. That makes "charizard psa" work without caring
// which order they're typed in, which is how people actually search a
// card catalog.
export function matchesQuery(query, haystackParts) {
  const terms = query.toLowerCase().split(/\s+/).filter(Boolean);
  if (!terms.length) return true;
  const hay = haystackParts.filter(Boolean).join(' ').toLowerCase();
  return terms.every((t) => hay.includes(t));
}
